// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");
var Spice = require("@greenlabs/ppx-spice/src/rescript/Spice.bs.js");
var Js_dict = require("@rescript/std/lib/js/js_dict.js");
var Js_json = require("@rescript/std/lib/js/js_json.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Nullable = require("../Nullable.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Util_Array = require("../util/Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../type/Type_Common.bs.js");
var Type_String = require("../type/Type_String.bs.js");
var Type_Teaser = require("../type/Type_Teaser.bs.js");
var Type_Sticker = require("../type/Type_Sticker.bs.js");

function lastviewed_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "is",
                    false,
                    Nullable.t_encode(Spice.boolToJson, v.is)
                  ],
                  [
                    "timecode",
                    false,
                    Nullable.t_encode(Spice.intToJson, v.timecode)
                  ],
                  [
                    "progress",
                    false,
                    Nullable.t_encode(Spice.floatToJson, v.progress)
                  ]
                ]));
}

function lastviewed_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is = Nullable.t_decode(Spice.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "is"), null));
  if (is.TAG === /* Ok */0) {
    var timecode = Nullable.t_decode(Spice.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "timecode"), null));
    if (timecode.TAG === /* Ok */0) {
      var progress = Nullable.t_decode(Spice.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "progress"), null));
      if (progress.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  is: is._0,
                  timecode: timecode._0,
                  progress: progress._0
                }
              };
      }
      var e = progress._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".progress" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = timecode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".timecode" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = is._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function type_encode(v) {
  return ["teaser"];
}

function type_decode(v) {
  var json_arr = Js_json.classify(v);
  if (typeof json_arr === "number") {
    return Spice.error(undefined, "Not a polyvariant", v);
  }
  if (json_arr.TAG !== /* JSONArray */3) {
    return Spice.error(undefined, "Not a polyvariant", v);
  }
  var json_arr$1 = json_arr._0;
  if (json_arr$1.length === 0) {
    return Spice.error(undefined, "Expected polyvariant, found empty array", v);
  }
  var tagged = Js_array.map(Js_json.classify, json_arr$1);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "teaser") {
    if (tagged.length !== 1) {
      return Spice.error(undefined, "Invalid number of arguments to polyvariant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: "teaser"
            };
    }
  }
  return Spice.error(undefined, "Invalid polymorphic constructor", Belt_Array.getExn(json_arr$1, 0));
}

function alternateResolution_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "url",
                    false,
                    Spice.stringToJson(v.url)
                  ],
                  [
                    "width",
                    false,
                    Spice.intToJson(v.width)
                  ],
                  [
                    "height",
                    false,
                    Spice.intToJson(v.height)
                  ]
                ]));
}

function alternateResolution_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var width = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
    if (width.TAG === /* Ok */0) {
      var height = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
      if (height.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  url: url._0,
                  width: width._0,
                  height: height._0
                }
              };
      }
      var e = height._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".height" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = width._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".width" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function image_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "url",
                    false,
                    Spice.stringToJson(v.url)
                  ],
                  [
                    "width",
                    false,
                    Spice.intToJson(v.width)
                  ],
                  [
                    "height",
                    false,
                    Spice.intToJson(v.height)
                  ],
                  [
                    "alternateResolutions",
                    false,
                    Spice.arrayToJson(alternateResolution_encode, v.alternateResolutions)
                  ]
                ]));
}

function image_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var url = Spice.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
  if (url.TAG === /* Ok */0) {
    var width = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "width"), null));
    if (width.TAG === /* Ok */0) {
      var height = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "height"), null));
      if (height.TAG === /* Ok */0) {
        var alternateResolutions = Spice.arrayFromJson(alternateResolution_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "alternateResolutions"), null));
        if (alternateResolutions.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    url: url._0,
                    width: width._0,
                    height: height._0,
                    alternateResolutions: alternateResolutions._0
                  }
                };
        }
        var e = alternateResolutions._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".alternateResolutions" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = height._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".height" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = width._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".width" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = url._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".url" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function favorite_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "is",
                    false,
                    Nullable.t_encode(Spice.boolToJson, v.is)
                  ]]));
}

function favorite_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var is = Nullable.t_decode(Spice.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "is"), null));
  if (is.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              is: is._0
            }
          };
  }
  var e = is._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "id",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.id)
                  ],
                  [
                    "kind",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.kind)
                  ],
                  [
                    "programId",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.programId)
                  ],
                  [
                    "url",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.url)
                  ],
                  [
                    "title",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.title)
                  ],
                  [
                    "subtitle",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.subtitle)
                  ],
                  [
                    "images",
                    false,
                    Nullable.t_encode((function (param) {
                            return Spice.arrayToJson(image_encode, param);
                          }), v.images)
                  ],
                  [
                    "markings",
                    false,
                    Nullable.t_encode(Type_Common.stickers_encode, v.markings)
                  ],
                  [
                    "duration",
                    false,
                    Nullable.t_encode(Type_Common.duration_in_min_from_js_encode, v.duration)
                  ],
                  [
                    "durationLabel",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.durationLabel)
                  ],
                  [
                    "description",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.description)
                  ],
                  [
                    "isSubscribed",
                    false,
                    Nullable.t_encode(Spice.boolToJson, v.isSubscribed)
                  ],
                  [
                    "lastviewed",
                    false,
                    Nullable.t_encode(lastviewed_encode, v.lastviewed)
                  ],
                  [
                    "favorite",
                    false,
                    Nullable.t_encode(favorite_encode, v.favorite)
                  ],
                  [
                    "trackingPixel",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.trackingPixel)
                  ]
                ]));
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var kind = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "kind"), null));
    if (kind.TAG === /* Ok */0) {
      var programId = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "programId"), null));
      if (programId.TAG === /* Ok */0) {
        var url = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "url"), null));
        if (url.TAG === /* Ok */0) {
          var title = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "title"), null));
          if (title.TAG === /* Ok */0) {
            var subtitle = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "subtitle"), null));
            if (subtitle.TAG === /* Ok */0) {
              var images = Nullable.t_decode((function (param) {
                      return Spice.arrayFromJson(image_decode, param);
                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "images"), null));
              if (images.TAG === /* Ok */0) {
                var markings = Nullable.t_decode(Type_Common.stickers_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "markings"), null));
                if (markings.TAG === /* Ok */0) {
                  var duration = Nullable.t_decode(Type_Common.duration_in_min_from_js_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "duration"), null));
                  if (duration.TAG === /* Ok */0) {
                    var durationLabel = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "durationLabel"), null));
                    if (durationLabel.TAG === /* Ok */0) {
                      var description = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
                      if (description.TAG === /* Ok */0) {
                        var isSubscribed = Nullable.t_decode(Spice.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "isSubscribed"), null));
                        if (isSubscribed.TAG === /* Ok */0) {
                          var lastviewed = Nullable.t_decode(lastviewed_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastviewed"), null));
                          if (lastviewed.TAG === /* Ok */0) {
                            var favorite = Nullable.t_decode(favorite_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "favorite"), null));
                            if (favorite.TAG === /* Ok */0) {
                              var trackingPixel = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trackingPixel"), null));
                              if (trackingPixel.TAG === /* Ok */0) {
                                return {
                                        TAG: /* Ok */0,
                                        _0: {
                                          id: id._0,
                                          kind: kind._0,
                                          programId: programId._0,
                                          url: url._0,
                                          title: title._0,
                                          subtitle: subtitle._0,
                                          images: images._0,
                                          markings: markings._0,
                                          duration: duration._0,
                                          durationLabel: durationLabel._0,
                                          description: description._0,
                                          isSubscribed: isSubscribed._0,
                                          lastviewed: lastviewed._0,
                                          favorite: favorite._0,
                                          trackingPixel: trackingPixel._0
                                        }
                                      };
                              }
                              var e = trackingPixel._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".trackingPixel" + e.path,
                                        message: e.message,
                                        value: e.value
                                      }
                                    };
                            }
                            var e$1 = favorite._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".favorite" + e$1.path,
                                      message: e$1.message,
                                      value: e$1.value
                                    }
                                  };
                          }
                          var e$2 = lastviewed._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".lastviewed" + e$2.path,
                                    message: e$2.message,
                                    value: e$2.value
                                  }
                                };
                        }
                        var e$3 = isSubscribed._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".isSubscribed" + e$3.path,
                                  message: e$3.message,
                                  value: e$3.value
                                }
                              };
                      }
                      var e$4 = description._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".description" + e$4.path,
                                message: e$4.message,
                                value: e$4.value
                              }
                            };
                    }
                    var e$5 = durationLabel._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".durationLabel" + e$5.path,
                              message: e$5.message,
                              value: e$5.value
                            }
                          };
                  }
                  var e$6 = duration._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".duration" + e$6.path,
                            message: e$6.message,
                            value: e$6.value
                          }
                        };
                }
                var e$7 = markings._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".markings" + e$7.path,
                          message: e$7.message,
                          value: e$7.value
                        }
                      };
              }
              var e$8 = images._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".images" + e$8.path,
                        message: e$8.message,
                        value: e$8.value
                      }
                    };
            }
            var e$9 = subtitle._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".subtitle" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = title._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".title" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
        }
        var e$11 = url._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".url" + e$11.path,
                  message: e$11.message,
                  value: e$11.value
                }
              };
      }
      var e$12 = programId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".programId" + e$12.path,
                message: e$12.message,
                value: e$12.value
              }
            };
    }
    var e$13 = kind._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".kind" + e$13.path,
              message: e$13.message,
              value: e$13.value
            }
          };
  }
  var e$14 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$14.path,
            message: e$14.message,
            value: e$14.value
          }
        };
}

function toResolution(images) {
  var transformToResolution = function (__x) {
    return Belt_Array.reduce(__x, [], (function (acc, param) {
                  var innerResolutions = Belt_Array.map(param.alternateResolutions, (function (param) {
                          return Type_Teaser.makeResolution(param.url, param.width, param.height);
                        }));
                  var currentResolution = Type_Teaser.makeResolution(param.url, param.width, param.height);
                  return Belt_Array.concatMany([
                              [currentResolution],
                              innerResolutions,
                              acc
                            ]);
                }));
  };
  return Belt_Option.getWithDefault(Belt_Option.map((images == null) ? undefined : Caml_option.some(images), transformToResolution), []);
}

function toDsTeaser(minutesLabel, param) {
  var id = param.id;
  var durationLabelTeaser = Curry._1(Type_String.Teaser.DurationLabel.makeFromNullable, param.durationLabel);
  var duration = Belt_Option.map(Caml_option.nullable_to_opt(param.duration), Type_Common.jsMinDurationToDuration);
  var stickers = Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(param.markings), Type_Sticker.makeFromCommonStickers), Type_Sticker.empty);
  var teaserKind = Type_Teaser.Kind.fromStickers(stickers);
  var stickers$1 = Type_Teaser.Helper.addClubDurationSticker((function (param) {
          return Type_Teaser.Helper.getDurationLabel(minutesLabel, param);
        }), duration, teaserKind, stickers);
  var programId = Curry._1(Type_String.Program.Id.makeFromNullable, param.programId);
  var teaserId = Curry._1(Type_String.Teaser.Id.makeFromNullable, id);
  var dsId = Type_Teaser.Helper.makeDsId(programId, teaserId);
  var key = Type_Teaser.Helper.makeKey(undefined, dsId);
  var kind = Belt_Option.flatMap(Caml_option.nullable_to_opt(param.kind), Type_Common.programKindFromJs);
  var tmp;
  if (kind !== undefined && (kind === "SHOW" || kind === "BONUS" || kind === "PLAYLIST" || kind === "TOPIC" || kind === "TV_SERIES" || kind === "HIGHLIGHT" || kind === "MAGAZINE")) {
    var match = Belt_Option.flatMap(Caml_option.nullable_to_opt(param.favorite), (function (param) {
            return Caml_option.nullable_to_opt(param.is);
          }));
    tmp = match !== undefined && match ? /* Available */({
          _0: /* Favorite */0
        }) : /* Available */({
          _0: /* NotFavorite */1
        });
  } else {
    tmp = /* NotAvailable */0;
  }
  return {
          audioVersions: undefined,
          availability: undefined,
          broadcastDates: undefined,
          callToAction: undefined,
          parentPage: undefined,
          credits: undefined,
          description: Curry._1(Type_String.Teaser.Description.makeFromNullable, param.description),
          dsId: dsId,
          duration: duration,
          durationLabel: durationLabelTeaser,
          favoriteStatus: tmp,
          href: Type_String.Href.makeFromNullableOrEmpty(param.url),
          geoblocking: undefined,
          id: Curry._1(Type_String.Teaser.Id.makeFromNullableOrEmpty, id),
          imageSrc: toResolution(param.images),
          key: key,
          kind: teaserKind,
          partners: undefined,
          program: {
            clip: undefined,
            description: undefined,
            firstBroadcastDate: undefined,
            genre: undefined,
            id: programId,
            kind: kind,
            shortDescription: undefined,
            trailer: undefined
          },
          progression: Belt_Option.getWithDefault(kind === "SHOW" ? Belt_Option.flatMap(Caml_option.nullable_to_opt(param.lastviewed), (function (param) {
                        var partial_arg = Caml_option.nullable_to_opt(param.timecode);
                        return Belt_Option.map(Caml_option.nullable_to_opt(param.progress), (function (param) {
                                      return Type_Common.Progression.makeFromPct(partial_arg, param);
                                    }));
                      })) : undefined, Type_Common.Progression.noProgression),
          shopUrl: undefined,
          stickers: stickers$1,
          subtitle: Belt_Option.map(Caml_option.nullable_to_opt(param.subtitle), (function (subtitle) {
                  return {
                          TAG: /* Normal */0,
                          _0: Curry._1(Type_String.Teaser.Subtitle.make, subtitle)
                        };
                })),
          title: Belt_Option.map(Caml_option.nullable_to_opt(param.title), (function (title) {
                  return {
                          TAG: /* Displayed */0,
                          _0: Curry._1(Type_String.Teaser.Title.make, title)
                        };
                })),
          trackingPixel: Type_String.TrackingPixel.makeFromNullable(param.trackingPixel),
          hoverBehavior: /* Normal */1
        };
}

var Teaser = {
  type_encode: type_encode,
  type_decode: type_decode,
  alternateResolution_encode: alternateResolution_encode,
  alternateResolution_decode: alternateResolution_decode,
  image_encode: image_encode,
  image_decode: image_decode,
  favorite_encode: favorite_encode,
  favorite_decode: favorite_decode,
  t_encode: t_encode,
  t_decode: t_decode,
  toResolution: toResolution,
  toDsTeaser: toDsTeaser
};

function meta_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "totalCount",
                    false,
                    Spice.intToJson(v.totalCount)
                  ],
                  [
                    "page",
                    false,
                    Spice.intToJson(v.page)
                  ],
                  [
                    "pages",
                    false,
                    Spice.intToJson(v.pages)
                  ],
                  [
                    "saveInterval",
                    false,
                    Nullable.t_encode(Spice.intToJson, v.saveInterval)
                  ]
                ]));
}

function meta_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var totalCount = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "totalCount"), null));
  if (totalCount.TAG === /* Ok */0) {
    var page = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "page"), null));
    if (page.TAG === /* Ok */0) {
      var pages = Spice.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pages"), null));
      if (pages.TAG === /* Ok */0) {
        var saveInterval = Nullable.t_decode(Spice.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "saveInterval"), null));
        if (saveInterval.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    totalCount: totalCount._0,
                    page: page._0,
                    pages: pages._0,
                    saveInterval: saveInterval._0
                  }
                };
        }
        var e = saveInterval._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".saveInterval" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = pages._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".pages" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = page._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".page" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = totalCount._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".totalCount" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_encode$1(encoder_a, v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "meta",
                    false,
                    meta_encode(v.meta)
                  ],
                  [
                    "data",
                    false,
                    Curry._1(encoder_a, v.data)
                  ]
                ]));
}

function t_decode$1(decoder_a, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var meta = meta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "meta"), null));
  if (meta.TAG === /* Ok */0) {
    var data = Curry._1(decoder_a, Belt_Option.getWithDefault(Js_dict.get(dict$1, "data"), null));
    if (data.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                meta: meta._0,
                data: data._0
              }
            };
    }
    var e = data._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".data" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = meta._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".meta" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function getData(metaData) {
  return metaData.data;
}

function getNextPage(t) {
  if (t.meta.page < t.meta.pages) {
    return t.meta.page + 1 | 0;
  }
  
}

var $$Response = {
  meta_encode: meta_encode,
  meta_decode: meta_decode,
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  getData: getData,
  getNextPage: getNextPage
};

function teasersResponse_encode(v) {
  return t_encode$1((function (param) {
                return Spice.arrayToJson(t_encode, param);
              }), v);
}

function teasersResponse_decode(v) {
  return t_decode$1((function (param) {
                return Spice.arrayFromJson(t_decode, param);
              }), v);
}

function magazines_encode(v) {
  return Spice.arrayToJson(Type_String.Teaser.Id.t_encode, v);
}

function magazines_decode(v) {
  return Spice.arrayFromJson(Type_String.Teaser.Id.t_decode, v);
}

function custom_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([[
                    "magazines",
                    false,
                    Nullable.t_encode(magazines_encode, v.magazines)
                  ]]));
}

function custom_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var magazines = Nullable.t_decode(magazines_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "magazines"), null));
  if (magazines.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              magazines: magazines._0
            }
          };
  }
  var e = magazines._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".magazines" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

var acceptCom_encode = Spice.boolToJson;

var acceptCom_decode = Spice.boolFromJson;

var email_encode = Spice.stringToJson;

var email_decode = Spice.stringFromJson;

function user_encode(v) {
  return Js_dict.fromArray(Spice.filterOptional([
                  [
                    "custom",
                    false,
                    Nullable.t_encode(custom_encode, v.custom)
                  ],
                  [
                    "acceptCom",
                    false,
                    Nullable.t_encode(acceptCom_encode, v.acceptCom)
                  ],
                  [
                    "email",
                    false,
                    Nullable.t_encode(email_encode, v.email)
                  ],
                  [
                    "gender",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.gender)
                  ],
                  [
                    "firstName",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.firstName)
                  ],
                  [
                    "lastName",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.lastName)
                  ],
                  [
                    "street",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.street)
                  ],
                  [
                    "city",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.city)
                  ],
                  [
                    "zipCode",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.zipCode)
                  ],
                  [
                    "country",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.country)
                  ],
                  [
                    "birthdate",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.birthdate)
                  ],
                  [
                    "over16",
                    false,
                    Nullable.t_encode(Spice.boolToJson, v.over16)
                  ],
                  [
                    "over18",
                    false,
                    Nullable.t_encode(Spice.boolToJson, v.over18)
                  ],
                  [
                    "ageVerificationToken",
                    false,
                    Nullable.t_encode(Spice.stringToJson, v.ageVerificationToken)
                  ]
                ]));
}

function user_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Spice.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Spice.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var custom = Nullable.t_decode(custom_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "custom"), null));
  if (custom.TAG === /* Ok */0) {
    var acceptCom = Nullable.t_decode(acceptCom_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "acceptCom"), null));
    if (acceptCom.TAG === /* Ok */0) {
      var email = Nullable.t_decode(email_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
      if (email.TAG === /* Ok */0) {
        var gender = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "gender"), null));
        if (gender.TAG === /* Ok */0) {
          var firstName = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "firstName"), null));
          if (firstName.TAG === /* Ok */0) {
            var lastName = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastName"), null));
            if (lastName.TAG === /* Ok */0) {
              var street = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "street"), null));
              if (street.TAG === /* Ok */0) {
                var city = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "city"), null));
                if (city.TAG === /* Ok */0) {
                  var zipCode = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "zipCode"), null));
                  if (zipCode.TAG === /* Ok */0) {
                    var country = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "country"), null));
                    if (country.TAG === /* Ok */0) {
                      var birthdate = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "birthdate"), null));
                      if (birthdate.TAG === /* Ok */0) {
                        var over16 = Nullable.t_decode(Spice.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "over16"), null));
                        if (over16.TAG === /* Ok */0) {
                          var over18 = Nullable.t_decode(Spice.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "over18"), null));
                          if (over18.TAG === /* Ok */0) {
                            var ageVerificationToken = Nullable.t_decode(Spice.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "ageVerificationToken"), null));
                            if (ageVerificationToken.TAG === /* Ok */0) {
                              return {
                                      TAG: /* Ok */0,
                                      _0: {
                                        custom: custom._0,
                                        acceptCom: acceptCom._0,
                                        email: email._0,
                                        gender: gender._0,
                                        firstName: firstName._0,
                                        lastName: lastName._0,
                                        street: street._0,
                                        city: city._0,
                                        zipCode: zipCode._0,
                                        country: country._0,
                                        birthdate: birthdate._0,
                                        over16: over16._0,
                                        over18: over18._0,
                                        ageVerificationToken: ageVerificationToken._0
                                      }
                                    };
                            }
                            var e = ageVerificationToken._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".ageVerificationToken" + e.path,
                                      message: e.message,
                                      value: e.value
                                    }
                                  };
                          }
                          var e$1 = over18._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".over18" + e$1.path,
                                    message: e$1.message,
                                    value: e$1.value
                                  }
                                };
                        }
                        var e$2 = over16._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".over16" + e$2.path,
                                  message: e$2.message,
                                  value: e$2.value
                                }
                              };
                      }
                      var e$3 = birthdate._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".birthdate" + e$3.path,
                                message: e$3.message,
                                value: e$3.value
                              }
                            };
                    }
                    var e$4 = country._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".country" + e$4.path,
                              message: e$4.message,
                              value: e$4.value
                            }
                          };
                  }
                  var e$5 = zipCode._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".zipCode" + e$5.path,
                            message: e$5.message,
                            value: e$5.value
                          }
                        };
                }
                var e$6 = city._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".city" + e$6.path,
                          message: e$6.message,
                          value: e$6.value
                        }
                      };
              }
              var e$7 = street._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".street" + e$7.path,
                        message: e$7.message,
                        value: e$7.value
                      }
                    };
            }
            var e$8 = lastName._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".lastName" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = firstName._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".firstName" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
        }
        var e$10 = gender._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".gender" + e$10.path,
                  message: e$10.message,
                  value: e$10.value
                }
              };
      }
      var e$11 = email._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".email" + e$11.path,
                message: e$11.message,
                value: e$11.value
              }
            };
    }
    var e$12 = acceptCom._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".acceptCom" + e$12.path,
              message: e$12.message,
              value: e$12.value
            }
          };
  }
  var e$13 = custom._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".custom" + e$13.path,
            message: e$13.message,
            value: e$13.value
          }
        };
}

function t_encode$2(v) {
  return t_encode$1((function (param) {
                return Spice.arrayToJson(user_encode, param);
              }), v);
}

function t_decode$2(v) {
  return t_decode$1((function (param) {
                return Spice.arrayFromJson(user_decode, param);
              }), v);
}

var defaultValue_custom = null;

var defaultValue_acceptCom = null;

var defaultValue_email = null;

var defaultValue_gender = null;

var defaultValue_firstName = null;

var defaultValue_lastName = null;

var defaultValue_street = null;

var defaultValue_city = null;

var defaultValue_zipCode = null;

var defaultValue_country = null;

var defaultValue_birthdate = null;

var defaultValue_over16 = null;

var defaultValue_over18 = null;

var defaultValue_ageVerificationToken = null;

var defaultValue = {
  custom: defaultValue_custom,
  acceptCom: defaultValue_acceptCom,
  email: defaultValue_email,
  gender: defaultValue_gender,
  firstName: defaultValue_firstName,
  lastName: defaultValue_lastName,
  street: defaultValue_street,
  city: defaultValue_city,
  zipCode: defaultValue_zipCode,
  country: defaultValue_country,
  birthdate: defaultValue_birthdate,
  over16: defaultValue_over16,
  over18: defaultValue_over18,
  ageVerificationToken: defaultValue_ageVerificationToken
};

function getAcceptCom(t) {
  return Belt_Option.getWithDefault(Belt_Option.flatMap(Util_Array.getFirstElement(t.data), (function (user) {
                    return Caml_option.nullable_to_opt(user.acceptCom);
                  })), false);
}

function getEmail(user) {
  return Caml_option.nullable_to_opt(user.email);
}

function getAgeVerificationStatus(user) {
  var match = user.over16;
  var match$1 = user.over18;
  var match$2 = user.ageVerificationToken;
  if (match == null) {
    return /* NotVerified */3;
  } else if (match) {
    if (match$1 == null) {
      return /* NotVerified */3;
    } else if (match$1) {
      if (match$2 == null) {
        return /* NotVerified */3;
      } else {
        return /* Verified18 */2;
      }
    } else if (match$2 == null) {
      return /* NotVerified */3;
    } else {
      return /* Verified16 */1;
    }
  } else if (!(match$1 == null) && !(match$1 || (match$2 == null))) {
    return /* Under16 */0;
  } else {
    return /* NotVerified */3;
  }
}

function getAgeVerificationToken(user) {
  return Caml_option.nullable_to_opt(user.ageVerificationToken);
}

var User = {
  magazines_encode: magazines_encode,
  magazines_decode: magazines_decode,
  custom_encode: custom_encode,
  custom_decode: custom_decode,
  acceptCom_encode: acceptCom_encode,
  acceptCom_decode: acceptCom_decode,
  email_encode: email_encode,
  email_decode: email_decode,
  user_encode: user_encode,
  user_decode: user_decode,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  defaultValue: defaultValue,
  getAcceptCom: getAcceptCom,
  getEmail: getEmail,
  getAgeVerificationStatus: getAgeVerificationStatus,
  getAgeVerificationToken: getAgeVerificationToken
};

function favorites_encode(v) {
  return t_encode$1((function (param) {
                return Spice.arrayToJson(t_encode, param);
              }), v);
}

function favorites_decode(v) {
  return t_decode$1((function (param) {
                return Spice.arrayFromJson(t_decode, param);
              }), v);
}

function getFirstTeaser(favorites) {
  return Belt_Array.get(favorites.data, 0);
}

var Favorite = {
  favorites_encode: favorites_encode,
  favorites_decode: favorites_decode,
  get: getData,
  getFirstTeaser: getFirstTeaser
};

function videosInProgress_encode(v) {
  return t_encode$1((function (param) {
                return Spice.arrayToJson(t_encode, param);
              }), v);
}

function videosInProgress_decode(v) {
  return t_decode$1((function (param) {
                return Spice.arrayFromJson(t_decode, param);
              }), v);
}

function getFirstTeaser$1(teaser) {
  return Belt_Array.get(teaser.data, 0);
}

var VideoInProgress = {
  videosInProgress_encode: videosInProgress_encode,
  videosInProgress_decode: videosInProgress_decode,
  get: getData,
  getFirstTeaser: getFirstTeaser$1
};

exports.lastviewed_encode = lastviewed_encode;
exports.lastviewed_decode = lastviewed_decode;
exports.Teaser = Teaser;
exports.$$Response = $$Response;
exports.teasersResponse_encode = teasersResponse_encode;
exports.teasersResponse_decode = teasersResponse_decode;
exports.User = User;
exports.Favorite = Favorite;
exports.VideoInProgress = VideoInProgress;
/* Type_Common Not a pure module */
